import 'zod-openapi/extend';
import { z } from 'zod';

// https://realwear.atlassian.net/wiki/spaces/RSE/pages/2438299674/Serial+Number+Format+Device+Identifications
export const Serial = {
  Hmt:         /^(MP|[DEP][123])[1-9][G-Z][1-9A-C][0-3][0-9][DN][0-9]\d{6}$/, // Standard HMT
  Navigator:   /^(MP|[DEP][123])A[1-9][G-Z][1-9A-C][0-3][0-9][DN][0-9]\d{6}$/, // Navigator 5XX (Archer)
  NavigatorZ1: /^(MP|[DEP][123])B[1-9][G-Z][1-9A-C][0-3][0-9][DN][0-9]\d{6}$/, // Navigator Z1 (Archer IS)
  Arc3:        /^(MP|[DEP][123])E[1-9][G-Z][1-9A-C][0-3][0-9][DN][0-9]\d{6}$/, // Arc 3
  Vuzix:       /^M005/,                                                           // Vuzix M400
  Rokid:       /^19.{14}$/,                                                       // Rokid
} as const;

const serialPatterns = Object.values(Serial);

export const DeviceIdSchema = z
  .string()
  .refine((v) => serialPatterns.some((re) => re.test(v)), 'Invalid device serial number format')
  .openapi({
    description: 'Unique identifier for a device that can be assigned to cohorts',
    example: 'MP1G101D1000000',
  });
